// extracted by mini-css-extract-plugin
export default {"icon":"_3Ioa5","iconWrapper":"_13fMI"};